"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShippingConfiguration = exports.setShippingConfiguration = exports.setQuantityConfiguration = exports.getQuantityConfiguration = exports.getCustomQuantitiesForMultipleKeys = exports.setCustomQuantitiesForMultipleKeys = exports.setCustomQuantities = exports.getCustomQuantities = exports.setCustomSettings = exports.getCustomSettings = void 0;

var _services = require("./services");

var getCustomQuantityId = function getCustomQuantityId(productCategoryId) {
  return "PRICEEXPLORER_CUSTOMQUANTITIES_".concat(productCategoryId);
};

var getCustomSettings = function getCustomSettings(resourceId, onGetAccessToken) {
  return (0, _services.request)("https://customizr.at.cimpress.io/v1/resources/".concat(resourceId, "/settings"), onGetAccessToken);
};

exports.getCustomSettings = getCustomSettings;

var setCustomSettings = function setCustomSettings(resourceId, settings, onGetAccessToken) {
  return (0, _services.request)("https://customizr.at.cimpress.io/v1/resources/".concat(resourceId, "/settings"), onGetAccessToken, 'PUT', JSON.stringify(settings));
};

exports.setCustomSettings = setCustomSettings;

var getCustomQuantities = function getCustomQuantities(resourceId, onGetAccessToken) {
  return getCustomSettings(getCustomQuantityId(resourceId), onGetAccessToken).then(function (result) {
    return result && result.quantities;
  });
};

exports.getCustomQuantities = getCustomQuantities;

var setCustomQuantities = function setCustomQuantities(resourceId, customQuantities, onGetAccessToken) {
  return setCustomSettings(getCustomQuantityId(resourceId), {
    quantities: customQuantities
  }, onGetAccessToken);
};

exports.setCustomQuantities = setCustomQuantities;

var setCustomQuantitiesForMultipleKeys = function setCustomQuantitiesForMultipleKeys(resourceIds, customQuantities, onGetAccessToken) {
  var promises = [];

  if (!(0, _services.isEmptyArray)(resourceIds)) {
    if (resourceIds.length === 1) {
      setCustomQuantities(resourceIds[0], customQuantities, onGetAccessToken);
    } else {
      resourceIds.forEach(function (resourceId) {
        promises.push(setCustomQuantities(resourceId, customQuantities, onGetAccessToken));
      });
      Promise.all(promises);
    }
  }

  return null;
};

exports.setCustomQuantitiesForMultipleKeys = setCustomQuantitiesForMultipleKeys;

var getCustomQuantitiesForMultipleKeys = function getCustomQuantitiesForMultipleKeys(resourceIds, onGetAccessToken) {
  var promises = [];

  if (!(0, _services.isEmptyArray)(resourceIds)) {
    if (resourceIds.length === 1) {
      return getCustomQuantities(resourceIds[0], onGetAccessToken);
    }

    resourceIds.forEach(function (resourceId) {
      promises.push(getCustomQuantities(resourceId, onGetAccessToken));
    });
    return Promise.all(promises);
  }

  return null;
};

exports.getCustomQuantitiesForMultipleKeys = getCustomQuantitiesForMultipleKeys;

var getQuantityConfiguration = function getQuantityConfiguration(onGetAccessToken) {
  return getCustomSettings('PRICEEXPLORER_QUANTITY_CONFIG', onGetAccessToken).then(function (result) {
    return result && result.configuration;
  });
};

exports.getQuantityConfiguration = getQuantityConfiguration;

var setQuantityConfiguration = function setQuantityConfiguration(configuration, onGetAccessToken) {
  return setCustomSettings('PRICEEXPLORER_QUANTITY_CONFIG', {
    configuration: configuration
  }, onGetAccessToken);
};

exports.setQuantityConfiguration = setQuantityConfiguration;

var setShippingConfiguration = function setShippingConfiguration(configuration, onGetAccessToken) {
  return setCustomSettings('PRICEEXPLORER_SHIPPING_CONFIG', {
    configuration: configuration
  }, onGetAccessToken);
};

exports.setShippingConfiguration = setShippingConfiguration;

var getShippingConfiguration = function getShippingConfiguration(onGetAccessToken) {
  return getCustomSettings('PRICEEXPLORER_SHIPPING_CONFIG', onGetAccessToken).then(function (result) {
    return result && result.configuration;
  });
};

exports.getShippingConfiguration = getShippingConfiguration;